


































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';
import { ErrorResponseMixin } from '@mixin';
import UserDataFields from '@part/forms/UserDataFields';
import UserAdresFields from '@part/forms/UserAdresFields';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            errorData: null,
            submitted: false,
            post: {
                id: '',
                gender: '',
                initials: '',
                lastname: '',
                lastname_prefix: '',
                street: '',
                postal: '',
                city: '',
                email: '',
                phone: '',
                notifications: false,
                function: '',
            }
        };
    },

    mixins: [
        ErrorResponseMixin,
    ],

    components: {
        UserDataFields,
        UserAdresFields,
    },

    created() {
        this.post.id = this.authUser.data.id;
        this.post.gender = this.authUser.data.gender;
        this.post.initials = this.authUser.data.initials;
        this.post.lastname_prefix = this.authUser.data.lastname_prefix;
        this.post.lastname = this.authUser.data.lastname;
        this.post.street = this.authUser.data.street;
        this.post.postal = this.authUser.data.postal;
        this.post.city = this.authUser.data.city;
        this.post.email = this.authUser.data.email;
        this.post.phone = this.authUser.data.phone;
        this.post.notifications = !this.authUser.data.notifications;
        this.post.function = this.authUser.data.function;
    },

    methods: {
        submit() {
            if (this.submitted) return;

            this.$validator.validate().then(valid => {
                if (!valid) return;

                this.submitted = true;

                const post = { ...this.post };
                post.notifications = (post.notifications) ? 0 : 1;

                this.$store.dispatch('user/update', post).then(response => {
                    if (response instanceof Error) {
                        this.errorData = this.getErrorMessage(response);
                        this.submitted = false;
                        return;
                    }

                    this.$router.push('/projects');
                });
            });
        },
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class ProfileForm extends Vue {}

